import { Button } from '@rocco/components/button';
import { ReactComponent as EnquiryIcon } from '@rocco/icons/svg/message.svg';
import { BASE_STYLE } from './style';
import type { ProfessionalMessageProps } from './types';
import { capitalize } from './utils';
import { useEnquiryModal } from '~/modules/enquiry/hooks/use-enquiry-modal';
import { createEnquiryProfessional } from './utils';
import { ReactComponent as ShareIcon } from '@rocco/icons/svg/arrow/arrow-x.svg';

interface ActionButtonsProps {
    name: string;
    summary: boolean;
    professionalProps: ProfessionalMessageProps;
    category: string;
    iconType?: 'message' | 'share';
    showEnquiryCTA?: boolean;
}

export const ActionButtons = ({
    name,
    professionalProps,
    category,
    summary,
    iconType = 'message',
    showEnquiryCTA = true,
}: ActionButtonsProps) => {
    let categoryName = capitalize(category);

    // Handle special cases for category display names
    if (categoryName === 'Interiordesigners') {
        categoryName = 'Interior Designer';
    } else if (categoryName === 'Joinery') {
        categoryName = 'Joiner';
    } else {
        // Remove trailing 's' for most categories
        categoryName = categoryName.endsWith('s')
            ? categoryName.slice(0, -1)
            : categoryName;
    }

    const enquiryLabel = `Message ${categoryName}`;

    const { openEnquiryModal } = useEnquiryModal({
        professional: createEnquiryProfessional(professionalProps),
        title: enquiryLabel,
        itemType: 'professional',
        siteTreeID: professionalProps.ProjectID,
        source: 'ProjectTeam',
        projectID: professionalProps.ProjectID,
        ctaLabel: enquiryLabel,
    });

    if (!showEnquiryCTA) {
        return null;
    }

    return (
        <div
            className={`flex ${BASE_STYLE.GAP_STANDARD} w-full opacity-100 ${BASE_STYLE.BOTTOM_MARGIN}`}
            style={
                summary
                    ? BASE_STYLE.INLINE_STYLES.FADE_IN_SLOWER
                    : BASE_STYLE.INLINE_STYLES.FADE_IN_SLOW
            }
        >
            <Button
                type="button"
                color="dark"
                className="uppercase"
                onClick={() =>
                    openEnquiryModal({
                        title: enquiryLabel,
                        ctaLabel: enquiryLabel,
                    })
                }
            >
                <span
                    className={`flex items-center ${BASE_STYLE.GAP_STANDARD}`}
                >
                    {enquiryLabel}
                    {iconType === 'message' ? (
                        <EnquiryIcon
                            aria-label={`Message ${name}`}
                            className="w-4 fill-white"
                        />
                    ) : (
                        <ShareIcon
                            aria-label={`Share ${name}`}
                            className="w-4 fill-white"
                        />
                    )}
                </span>
            </Button>
        </div>
    );
};
